import React, { Fragment } from 'react';
import ListaHeroes from './ListaHeroes';
const VistaDC = (props) => {



    return (
        <Fragment>
            <br/>
            <ListaHeroes editorial="DC Comics" />
        </Fragment>
    )
}
export default VistaDC;